export const termsAndConditions = {
  lastUpdated: "January 2026",
  companyName: "Flash",
  companyAddress: "Gudalur, Tamil Nadu, India",
  sections: [
    {
      title: "1. Acceptance of Terms",
      content: `By accessing and using the Flash mobile application and services ("Service"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our Service.

These Terms and Conditions constitute a legally binding agreement between you and Flash regarding your use of the Service.`
    },
    {
      title: "2. Service Description",
      content: `Flash provides an on-demand delivery platform connecting customers with local stores and delivery partners in Gudalur and surrounding areas. Our services include:

• Online ordering of groceries, household items, and other products
• Fast delivery within 15-120 minutes depending on location
• Cash on Delivery (COD) and UPI payment options
• Order tracking and customer support

We reserve the right to modify, suspend, or discontinue any aspect of the Service at any time without prior notice.`
    },
    {
      title: "3. User Accounts",
      content: `To use our Service, you must:

• Be at least 18 years of age
• Provide accurate and complete registration information
• Maintain the security of your account credentials
• Accept responsibility for all activities under your account
• Notify us immediately of any unauthorized use

We reserve the right to suspend or terminate accounts that violate these terms or engage in fraudulent activity.`
    },
    {
      title: "4. Orders and Payments",
      content: `Order Terms:
• Minimum order value: ₹149
• Free delivery on orders ₹149 and above
• ₹20 delivery fee applies for orders below ₹149
• Prices are subject to change without notice
• Product availability is not guaranteed

Payment Terms:
• We accept Cash on Delivery (COD) and UPI payments
• Payment must be made at the time of delivery
• You are responsible for having exact change for COD orders
• All prices are in Indian Rupees (INR)

Cancellation Policy:
• Orders can be cancelled before confirmation
• Once confirmed, contact support immediately via WhatsApp
• Refunds will be processed as per our refund policy`
    },
    {
      title: "5. Delivery Terms",
      content: `Delivery Zones:
• Within 6 km: 15-45 minutes delivery time
• 6-12 km: 35-120 minutes delivery time
• Service available in Gudalur and nearby areas

Delivery Conditions:
• Accurate delivery address must be provided
• Someone must be available to receive the order
• Delivery partners may contact you for directions
• We are not responsible for delays due to weather, traffic, or unforeseen circumstances
• Failed deliveries due to incorrect address or unavailability may incur additional charges`
    },
    {
      title: "6. Product Quality and Returns",
      content: `Quality Assurance:
• We strive to deliver fresh and quality products
• Products are sourced from trusted local stores
• Check items upon delivery for any damage or discrepancies

Returns and Refunds:
• We do not accept returns on delivered items
• Damaged or incorrect items will be replaced or refunded
• Report issues within 24 hours with photos via WhatsApp
• Refunds will be processed within 5-7 business days
• Perishable items cannot be returned once delivered`
    },
    {
      title: "7. User Conduct",
      content: `You agree not to:

• Use the Service for any illegal or unauthorized purpose
• Interfere with or disrupt the Service or servers
• Attempt to gain unauthorized access to any part of the Service
• Harass, abuse, or harm delivery partners or support staff
• Submit false or misleading information
• Use automated systems to access the Service
• Resell or commercially exploit the Service

Violation of these terms may result in immediate account termination and legal action.`
    },
    {
      title: "8. Intellectual Property",
      content: `All content, features, and functionality of the Service, including but not limited to:

• Text, graphics, logos, images, and software
• The Callsouq name and logo
• Design, layout, and look-and-feel

Are owned by Flash and protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or create derivative works without our express written permission.`
    },
    {
      title: "9. Limitation of Liability",
      content: `To the maximum extent permitted by law:

• Callsouq is not liable for any indirect, incidental, or consequential damages
• Our total liability shall not exceed the amount paid for the specific order
• We are not responsible for product quality issues beyond our control
• We are not liable for delays caused by third parties or force majeure events
• Service is provided "as is" without warranties of any kind

Some jurisdictions do not allow limitation of liability, so these limitations may not apply to you.`
    },
    {
      title: "10. Privacy and Data Protection",
      content: `Your privacy is important to us. Our Privacy Policy explains:

• What information we collect and why
• How we use and protect your data
• Your rights regarding your personal information
• How we share information with third parties

By using our Service, you consent to our data practices as described in our Privacy Policy.`
    },
    {
      title: "11. Modifications to Terms",
      content: `We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to the app. Your continued use of the Service after changes constitutes acceptance of the modified terms.

We will notify users of significant changes via:
• In-app notifications
• Email notifications
• WhatsApp messages

It is your responsibility to review these terms periodically.`
    },
    {
      title: "12. Governing Law and Dispute Resolution",
      content: `These Terms shall be governed by and construed in accordance with the laws of India, without regard to conflict of law provisions.

Dispute Resolution:
• First, contact our support team to resolve issues amicably
• If unresolved, disputes will be subject to arbitration in Gudalur, Tamil Nadu
• You agree to waive any right to a jury trial
• Class action lawsuits are not permitted

The courts of Gudalur, Tamil Nadu shall have exclusive jurisdiction over any disputes.`
    },
    {
      title: "13. Contact Information",
      content: `For questions about these Terms and Conditions, please contact us:

Flash
Gudalur, Tamil Nadu, India

Support Hours: 6:00 AM - 10:00 PM (Daily)
WhatsApp: +91 91234 56789
Instagram: @flash.delivery.in
Email: support@flash.delivery

We aim to respond to all inquiries within 24 hours.`
    },
    {
      title: "14. Severability",
      content: `If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that these Terms will otherwise remain in full force and effect.`
    },
    {
      title: "15. Entire Agreement",
      content: `These Terms and Conditions, together with our Privacy Policy, constitute the entire agreement between you and Flash regarding the use of the Service, superseding any prior agreements.`
    }
  ]
};

// Made with Bob
